module.exports = __webpack_public_path__ + "img/HQ-PA2W1L.9e24cf7f.jpg";